const resources = {
    pageTitle: 'Sign In',
    // SIM-2 / ACS-4126 — credential-entry screen
    credentialLabel: 'Phone or Email Address',
    credentialPlaceholder: '(123) 456-7890',
    subtitlePrefix: 'Sign in or create an account to enjoy ',
    subtitleBold: 'FREE standard shipping',
    subtitleSuffix: ' on all orders.',
    newToSephora: 'New to Sephora?',
    continueButton: 'Continue',
    createAccountButton: 'Create Account',
    invalidCredential: 'Enter a valid email address or phone number.',
    notFound:
        'We couldn\'t find an account with that email or phone number. Check your entry or create an account.',
    closedAccount: 'This account has been closed. Contact customer service for assistance.',
    blockedAccount: 'Your account requires attention. Contact customer service to restore access.',
    // ERR_400004 - store-registered user with incomplete registration; backend
    // triggers a verification email (same flow as reset-password).
    storeRegistered:
        'Your account needs to be verified. We\'ve sent a verification email - please check your inbox to continue.',
    genericError: 'Something went wrong. Please try again in a few moments.',
    // SIM-10 / ACS-4134 — cross-cutting states.
    // AC-028 session timeout during the sign-in flow (redirect to /signin, cleared state).
    sessionExpired: 'Your session has expired. Please try again.',
    // BR-026/AC-026 — shown when a submit exceeds the 10s timeout.
    timeoutMessage: 'This is taking longer than expected. Please try again.',
    // Accessible label for the in-flight circular loader (Figma 270-85083).
    loadingLabel: 'Loading',
    // SIM-7 / ACS-4131 — OTP-first authorization + OTP entry, Figma node 270-84177
    // (radio group + single "Send" button; BR-034: always "verification code",
    // never "passcode").
    editLabel: 'Edit',
    // aria-label for the Edit affordance (AC-AUTH-EDIT / AC-AUTH-BACK: Edit is the
    // return-to-credential path in this frame — no separate back chevron).
    editAriaLabel: 'Edit email or phone number',
    // Radiogroup accessible name. Carries the BR-034 "verification code"
    // terminology; option labels also use it (Figma copy).
    authorizationSubtitle: 'How would you like to receive your verification code?',
    // Radio-option labels (BR-007 order: SMS, Email, Password) — Figma 270-84177.
    // The SMS label carries "verification code" (BR-034).
    smsMethodLabel: 'Text me a verification code',
    emailMethodLabel: 'Email me a verification code',
    passwordMethodLabel: 'Enter password',
    // SMS-consent copy under the SMS option only (BR-033 / AC-AUTH-SMSCONSENT).
    // The TEXT TERMS + PRIVACY POLICY anchors are rendered as real, UPPERCASED
    // links by the screen (Figma 270-84177).
    smsConsentPrefix:
        'The information collected here will only be used for verification purposes. Message and data rates may apply. By clicking "Send", you (1) agree to the current version of our ',
    smsConsentTextTerms: 'Text Terms',
    smsConsentMiddle: ', and (2) have read Sephora\'s ',
    smsConsentPrivacy: 'Privacy Policy',
    smsConsentSuffix: '.',
    // Single commit button for the selected method (Figma: always "Send").
    sendButton: 'Send',
    // OTP entry (Phase 3) — Figma node 270-84837 (phone) / 181-169990 (email).
    // Accessible group name for the 6-box code entry (kept for OTP-03 a11y).
    otpInputAriaLabel: 'Enter 6-digit verification code',
    // Per-box accessible name for the shared components/OtpInputGroup — {0} is the
    // 1-based box index, interpolated by OtpInputGroup via stringUtils.format.
    otpInputBoxAriaLabel: 'Verification code input {0}',
    // Section label + heading switch on sms-vs-email (BR-034: "verification code").
    otpSectionLabelPhone: 'Phone Verification',
    otpSectionLabelEmail: 'Email Verification',
    otpHeadingPhone: 'Check your messages and enter your verification code',
    otpHeadingEmail: 'Check your email and enter your verification code',
    // Subtitle: "You will receive a code at {maskedDestination} if it is
    // registered with a Beauty Insider account." — the masked destination is bold
    // inline and interpolated by the screen (BR-021: never the raw value).
    otpSubtitlePrefix: 'You will receive a code at ',
    otpSubtitleSuffix: ' if it is registered with a Beauty Insider account.',
    // Resend line: "Didn't get {channel}? Resend code in {N} seconds" — the channel
    // + countdown switch on mode; the "Resend code" portion becomes a link once the
    // cooldown elapses.
    resendPrefix: 'Didn\'t get ',
    resendChannelPhone: 'the SMS',
    resendChannelEmail: 'an email',
    resendQuestion: '? ',
    resendButton: 'Resend code',
    // Countdown template — the seconds count is interpolated by the screen.
    resendCountdownPrefix: 'Resend code in ',
    resendCountdownSuffix: ' seconds',
    // White pill with a 2px black border; navigates back to the method-choice
    // (authorization) screen (SIM-7 scope).
    tryAnotherMethodButton: 'Try Another Method',
    // AC-036: identical copy for expired AND incorrect (no leakage, BR-029). The
    // masked destination is appended by the screen.
    otpExpiredOrIncorrect: 'That code has expired or is incorrect. We sent a new verification code to ',
    // Send-failure copy (SEND-04).
    otpSendFailed: 'We couldn\'t send your verification code. Try a different method.',
    // BR-025 resend limit reached.
    otpLimitMessage: 'Too many attempts. Try a different sign-in method or contact customer service.',
    // SIM-9 / ACS-4133 - inline password on AuthorizationScreen (Figma 252-79196).
    // Floating label for the revealed password field.
    passwordFieldLabel: 'Password',
    // Inline validation shown when Sign In is pressed with an empty password.
    passwordRequired: 'Enter your password.',
    // "Forgot Password?" link that opens the existing forgot-password modal.
    forgotPasswordLink: 'Forgot Password?',
    // Password-consent copy shown in place of the SMS consent when password is
    // selected; the TERMS OF USE + PRIVACY POLICY anchors are rendered as real,
    // UPPERCASED links by the screen (Figma 252-79196).
    passwordConsentPrefix: 'By clicking "Sign In", you (1) agree to the current version of our ',
    passwordConsentTerms: 'Terms of Use',
    passwordConsentMiddle: ' and (2) have read Sephora\'s ',
    passwordConsentPrivacy: 'Privacy Policy',
    passwordConsentSuffix: '.',
    // Primary-button label swap on the password branch (Figma: "Send" -> "Sign In").
    signInButton: 'Sign In',
    // SIM-9 / ACS-4133 - phone-disambiguation email-confirmation mode (Figma 1466-19076).
    // Generic prompt (no account-count leak, BR-002/003).
    emailConfirmSubtitle: 'Enter your email address associated with your account.',
    emailConfirmLabel: 'Email Address'
};

export default function getResource(label) {
    return resources[label];
}
